import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-article-search-card',
    templateUrl: './article-search-card.component.html',
    styleUrls: ['./article-search-card.component.scss'],
    imports:[RouterModule,CommonModule]
})
export class ArticleSearchCardComponent {

  @Input() data: any;

  constructor() { }
  ngOnInit(){
    //console.log(this.data.posterUrl)
  }

  
}
